import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import * as NetworkLoggerActions from './network-logger.actions';
import * as fromNetworkLogger from './network-logger.reducer';
import { first } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable({ providedIn: 'root' })
export class NetworkLoggerFacade {
  networkLogs$ = this.store.pipe(select(fromNetworkLogger.selectAll));

  constructor(private store: Store<fromNetworkLogger.State>) {
    if (!environment.production) {
      (window as any).proHerz = this;
    }
  }

  logNetworkActivity(entry: fromNetworkLogger.NetworkLogEntry): void {
    this.store.dispatch(NetworkLoggerActions.logNetworkActivity({ entry }));
  }

  clearNetworkActivityLogs(): void {
    this.store.dispatch(NetworkLoggerActions.clearNetworkActivityLogs());
  }

  /**
   * Method for outputting the current log entries.
   * Usage in the dev-console: proHerz.listLogs()
   */
  listLogs() {
    this.networkLogs$.pipe(first()).subscribe((logs) => console.log(logs));
  }
}
